function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import typography from '../utils/typography';
import { useTheme } from '@veneer/theme';
var iconSize = '24px';
var useStyles = _ref => {
  var {
    disabled,
    hasIcon,
    isSelected,
    leadingAreaWhiteSpace
  } = _ref;
  var theme = useTheme();
  return {
    menuItem: _objectSpread(_objectSpread(_objectSpread({
      alignItems: 'center',
      borderRadius: theme.borderRadius3,
      boxSizing: 'border-box',
      color: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.default,
      cursor: !disabled ? 'pointer' : undefined,
      border: '1px solid transparent',
      display: 'flex',
      minHeight: "calc(".concat(theme.layout.size8, " + ").concat(theme.layout.size2, ")"),
      minWidth: '180px',
      padding: "".concat(theme.layout.size2, " ").concat(theme.layout.size3),
      pointerEvents: 'auto',
      position: 'relative',
      textDecoration: 'none',
      transition: 'background-color 100ms linear, color 100ms linear'
    }, !hasIcon && leadingAreaWhiteSpace && {
      paddingLeft: "calc(".concat(theme.layout.size2, " + ").concat(iconSize, " + ").concat(theme.layout.size2, ")")
    }), {}, {
      svg: {
        fill: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.default
      }
    }, !disabled && _objectSpread(_objectSpread({}, isSelected && {
      backgroundColor: theme.palette.primary.background,
      color: theme.palette.primary.active,
      svg: {
        fill: theme.palette.primary.active
      },
      ':focus': {
        borderColor: theme.palette.primary.default
      }
    }), !isSelected && {
      ':hover': {
        backgroundColor: theme.palette.neutral.backgroundLight,
        color: theme.palette.foreground.default,
        svg: {
          fill: theme.palette.foreground.default
        }
      },
      ':focus': {
        borderColor: theme.palette.primary.default,
        color: theme.palette.foreground.default,
        svg: {
          fill: theme.palette.foreground.default
        }
      },
      ':active': {
        backgroundColor: theme.palette.neutral.background,
        color: theme.palette.foreground.default,
        svg: {
          fill: theme.palette.foreground.default
        }
      }
    })), theme.mode === 'contrast' && !disabled && _objectSpread(_objectSpread(_objectSpread({
      color: theme.palette.primary.default,
      svg: {
        fill: theme.palette.primary.default
      }
    }, isSelected && {
      backgroundColor: theme.palette.primary.active,
      color: theme.palette.foreground.inverse,
      svg: {
        fill: theme.palette.foreground.inverse
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.active
      }
    }), !isSelected && {
      '&:focus, &:hover': {
        backgroundColor: theme.palette.primary.hover,
        color: theme.palette.foreground.inverse,
        svg: {
          fill: theme.palette.foreground.inverse
        }
      }
    }), {}, {
      '&:active': {
        backgroundColor: theme.palette.primary.active,
        color: theme.palette.foreground.inverse,
        svg: {
          fill: theme.palette.foreground.inverse
        }
      }
    })),
    leadingArea: {
      display: 'flex',
      marginLeft: "-".concat(theme.layout.size1),
      marginRight: theme.layout.size2
    },
    trailingArea: {
      display: 'flex',
      marginLeft: theme.layout.size2,
      marginRight: "-".concat(theme.layout.size1)
    },
    label: _objectSpread({
      flex: 1,
      pointerEvents: 'none'
    }, typography(theme).label)
  };
};
export default useStyles;